// extracted by mini-css-extract-plugin
module.exports = {"reveal-wrapper":"RevealWrapper_reveal-wrapper__rbKYu"};